import {Slider} from '@material-ui/core';
import React from 'react'
import {Controller, useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {openAlert} from '../../slices/alert';
import {closeDialog} from '../../slices/dialog';
import {selectUid} from '../../slices/auth';
import {addStudentSoftSkillsFeedback} from '../../api/student/softSkillsFeedback';

export const RadarChartFeedback = () => {
    const dispatch = useDispatch();
    const uid = useSelector(selectUid);
    const {register, handleSubmit, errors, control} = useForm({
        defaultValues: {
            stars: 0,
            comment: ""
        }
    });
    const {t} = useTranslation();

    const onSave = form => {
        const feedback = {
            ...form,
            assessmentId: "onboarding",
            studentId: uid
        }
        addStudentSoftSkillsFeedback(feedback).then(() => {
            dispatch(openAlert({type: "success", message: t("alert_feedback_thanks")}))
            dispatch(closeDialog());
        });
    };

    return (
        <div className="radarChartFeedback">
            <form onSubmit={handleSubmit(onSave)}>
                <div className="element">
                    <div className="label">{t("student_ssFeedback_value_label")}<span className="asterisk">*</span>
                    </div>
                    <div className="slider">
                        <div className="slider__text">{t("slider_low")}</div>
                        <Controller
                            name="stars"
                            onChange={(_, data) => data}
                            control={control}
                            rules={{required: true, validate: value => value > 0}}
                            defaultValue={0}
                            render={(props) => (
                                <Slider
                                    {...props}
                                    onChange={(_, value) => {
                                        props.onChange(value);
                                    }}
                                    marks={true}
                                    valueLabelDisplay="auto"
                                    min={1}
                                    max={10}
                                    step={1}
                                />
                            )}
                        />
                        <div className="slider__text">{t("slider_high")}</div>
                    </div>
                    {errors["stars"] && <p className="error">{t("student_ssFeedback_value_error")}</p>}
                </div>
                <div className="element">
                    <div className="label">{t("student_ssFeedback_expl_label")}</div>
                    <textarea
                        type="text"
                        placeholder={t("student_ssFeedback_expl_ph")}
                        ref={register}
                        name="comment"
                        rows="10"
                    ></textarea>
                </div>
                <input type="submit" value={t("student_ssFeedback_submit")}></input>
            </form>
        </div>
    );
}
